<nb-card class="no-edge-card mb-0 modal-height-100-62">
	<div class="closeModal">
		<nb-icon class="m-1" icon="close-circle" [options]="{ animation: { type: 'zoom' } }" (click)="closeModal('')"
			nbTooltip="Cerrar" nbTooltipPlacement="left">
		</nb-icon>
	</div>
	<nb-card-header class="border-bottom-0 background_themecolor">
		<div class="container">
			<div class="px-2 px-sm-5 py-2">
				<h4 class="text-center">Panel de Control - Comercial</h4>
			</div>
		</div>
	</nb-card-header>
	<nb-card-body>
		<div class="comercial-panel-grid">
			<div class="comercial-panel-item" (click)="goToCRM()">
				<div class="panel-item-icon">
					<i class="fa fa-handshake-o"></i>
				</div>
				<div class="panel-item-label">CRM</div>
				<div class="panel-item-desc">Gestión de centros, contactos y pipeline comercial</div>
			</div>
		</div>
	</nb-card-body>
</nb-card>
